import { render, staticRenderFns } from "./diseasesListing.vue?vue&type=template&id=32a670c4&scoped=true"
import script from "./diseasesListing.vue?vue&type=script&lang=js"
export * from "./diseasesListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a670c4",
  null
  
)

export default component.exports